module.exports = __webpack_public_path__ + "media/images/locales/fi-d26e6639eeb08dec00885a3b8d54a39f.svg";